import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Label extends BaseOption {
  static userInterfaceComponent = {
    label: "Label",
    component: inspectorTools.RICH_TEXT_INPUT,
  };

  static defaultValue = "Add your label here";
}
